module.exports = __webpack_public_path__ + "img/Dantam Bridal 11.f421813a.jpg";